  (() => {
    if (window.__hcCartPaymentBound) return;
    window.__hcCartPaymentBound = true;

    const LABELS = { prepaid: 'Pre-paid', partial_cod: 'Cash on delivery' };

    // Close the cart drawer (native <dialog> + custom drawer variants) so it does
    // not sit above the Razorpay popup. Tries every close path the theme uses.
    const closeCartDrawer = () => {
      try {
        document.querySelectorAll('dialog[open]').forEach((d) => {
          if (d.closest('cart-drawer-component, .hc-cart-drawer, [class*="cart-drawer"]') || d.classList.toString().includes('cart')) {
            try { d.close(); } catch (e) { d.removeAttribute('open'); }
          }
        });
        const comp = document.querySelector('cart-drawer-component');
        if (comp && typeof comp.close === 'function') { try { comp.close(); } catch (e) {} }
        // Fallback: click any cart close control + clear open body classes.
        document.querySelectorAll('[data-hc-cart-close], .cart-drawer__close, [aria-label="Close cart"]').forEach((b) => {
          try { b.click(); } catch (e) {}
        });
        document.body.classList.remove('hc-cart-open', 'cart-open', 'drawer-open');
      } catch (e) { /* never block checkout */ }
    };

    const paintPayment = (payment, value) => {
      if (!payment) return;
      const v = value === 'partial_cod' ? 'partial_cod' : 'prepaid';
      const isCod = v === 'partial_cod';

      const prepaidNote = payment.querySelector('[data-hc-note-prepaid]');
      const codNote = payment.querySelector('[data-hc-note-cod]');
      if (prepaidNote) prepaidNote.hidden = isCod;
      if (codNote) codNote.hidden = !isCod;

      const label = payment.querySelector('[data-hc-payment-trigger-label]');
      if (label) label.textContent = LABELS[v];

      payment.querySelectorAll('[data-hc-payment-choice]').forEach((choice) => {
        const on = (choice.getAttribute('data-value') || 'prepaid') === v;
        choice.classList.toggle('is-selected', on);
        choice.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    };

    const refreshPaymentCards = (scope = document) => {
      scope.querySelectorAll('[data-hc-cart-payment]').forEach((payment) => {
        const holder = payment.querySelector('[data-hc-payment-option]');
        paintPayment(payment, holder?.value || 'prepaid');
      });
    };

    const setSheet = (payment, open) => {
      const sheet = payment?.querySelector('[data-hc-payment-sheet]');
      const trigger = payment?.querySelector('[data-hc-payment-trigger]');
      if (!sheet) return;
      sheet.hidden = !open;
      sheet.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('hc-payment-sheet-open', open);
    };

    const findPaymentRoot = (trigger) => {
      const scopedRoot = trigger?.closest?.('.cart-summary__inner, .cart-drawer__summary, .cart-page__summary');
      return scopedRoot?.querySelector?.('[data-hc-cart-payment]') || document.querySelector('[data-hc-cart-payment]');
    };

    const buildPaymentAttributes = (paymentRoot) => {
      const selected = paymentRoot?.querySelector?.('[data-hc-payment-option]')?.value || 'prepaid';

      if (selected === 'partial_cod') {
        return {
          'Payment preference': 'Partial COD',
          'Payment option': 'Cash on delivery',
          'Partial COD rate': `${paymentRoot?.dataset.codRate || '30'}%`,
          'Partial COD threshold': paymentRoot?.dataset.codThresholdMoney || '',
          'Partial COD cart total': paymentRoot?.dataset.codTotalMoney || '',
          'Partial COD advance amount': paymentRoot?.dataset.codAdvanceMoney || '',
          'Partial COD balance amount': paymentRoot?.dataset.codBalanceMoney || '',
        };
      }

      return {
        'Payment preference': 'Pre-paid',
        'Payment option': 'Pre-paid',
        'Partial COD rate': '',
        'Partial COD threshold': '',
        'Partial COD cart total': '',
        'Partial COD advance amount': '',
        'Partial COD balance amount': '',
      };
    };

    const persistPaymentChoice = async (paymentRoot) => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: buildPaymentAttributes(paymentRoot) }),
        });
      } catch (error) {
        console.warn('Unable to save cart payment preference.', error);
      }
    };

    // Save the payment preference on checkout WITHOUT blocking the click, so
    // Razorpay Magic Checkout (or any accelerated checkout) can still open.
    // Uses sendBeacon so the request survives the navigation Razorpay triggers.
    const beaconPaymentChoice = (trigger) => {
      try {
        const paymentRoot = findPaymentRoot(trigger);
        const body = JSON.stringify({ attributes: buildPaymentAttributes(paymentRoot) });
        if (navigator.sendBeacon) {
          navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/json' }));
        } else {
          fetch('/cart/update.js', {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body,
          });
        }
      } catch (error) {
        console.warn('Unable to save cart payment preference before checkout.', error);
      }
    };

    document.addEventListener('click', (event) => {
      const payment = event.target.closest?.('[data-hc-cart-payment]');

      const trigger = event.target.closest?.('[data-hc-payment-trigger]');
      if (trigger && payment) {
        event.preventDefault();
        setSheet(payment, true);
        return;
      }

      const choice = event.target.closest?.('[data-hc-payment-choice]');
      if (choice && payment) {
        event.preventDefault();
        event.stopPropagation();
        const value = choice.getAttribute('data-value') || 'prepaid';
        const holder = payment.querySelector('[data-hc-payment-option]');
        if (holder) holder.value = value;
        paintPayment(payment, value);
        setSheet(payment, false);
        persistPaymentChoice(payment);
        return;
      }

      if (event.target.closest?.('[data-hc-payment-dismiss]') && payment) {
        event.preventDefault();
        setSheet(payment, false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openSheet = document.querySelector('[data-hc-payment-sheet].is-open');
      if (openSheet) setSheet(openSheet.closest('[data-hc-cart-payment]'), false);
    });

    // Non-blocking: save the choice, then let the native checkout button proceed
    // so Razorpay Magic Checkout can intercept and open its modal.
    document.addEventListener('click', (event) => {
      const checkoutButton = event.target.closest?.('.cart__checkout-button[name="checkout"]');
      if (!checkoutButton || checkoutButton.disabled) return;
      beaconPaymentChoice(checkoutButton);
      // Close the cart drawer so it does not overlap the Razorpay popup.
      // The cart drawer is a native <dialog>, which renders in the browser top
      // layer above all z-index, so it MUST be closed, not just z-index-lowered.
      closeCartDrawer();
    });

    refreshPaymentCards();
  })();
